export default {
  data() {
    return {
      pageOffset: 0
    };
  },
  mounted() {
    window.addEventListener("scroll", this.update);
  },
  destroyed() {
    window.removeEventListener("scroll", this.update);
  },
  methods: {
    update() {
      this.pageOffset = window.pageYOffset;
    }
  }
};



// WEBPACK FOOTER //
// ./resources/js/mixins/scrollMixin.js